import { __awaiter, __generator } from "tslib";
import { Search } from "./types.js";
import { GraphRest } from "../rest.js";
export { Search, } from "./types.js";
GraphRest.prototype.query = function () {
    var requests = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        requests[_i] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, this.childConfigHook(function (_a) {
                    var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
                    return Search(baseUrl).configure(options).setRuntime(runtime).executeQuery({ requests: requests });
                })];
        });
    });
};
//# sourceMappingURL=index.js.map